import { capitalizeFirstLetter } from './cvGenerator';

const BASE_URL = 'https://mindpal.co';

const segmentToName = (segment: string) =>
  segment
    .split('-')
    .map((word) => capitalizeFirstLetter(word))
    .join(' ');

export const createBreadcrumbSchema = (path: string) => {
  const segments = path.split('/').filter(Boolean);

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'MindPal',
        item: BASE_URL,
      },
      ...segments.map((segment, index) => ({
        '@type': 'ListItem',
        position: index + 2,
        name: segmentToName(segment),
        item: `${BASE_URL}/${segments.slice(0, index + 1).join('/')}`,
      })),
    ],
  };
};
